module.exports = __webpack_public_path__ + "img/logo2.bd6c9e28.png";